<template>
  <b-modal
    id="add-member-btn"
    :centered="true"
    no-close-on-backdrop
    size="sm"
    class="add-member-modal"
    title="Add Member User"
    :hide-footer="true"
    @show="resetForm"
  >
    <form  action="#">
      <div class="addMemberContent">
        <b-form-group
          id="input-group-1"
          label="Email address"
          label-for="input-1"
          class="required d-block"
        >
          <b-form-input
            id="input-1"
            type="email"
            placeholder="Enter Email Address"
            required
            v-model="form.email"
          ></b-form-input>
        </b-form-group>
        <div class="validation-wrapper mb-3">
          <div
              v-if="showOtpSectionEmail"
              class="mem-admin-otp-validate-btn mb-3"
              id="validate_otp"
            >
              <a
                href="#"
                class="validate-via-otp-link validate-btn"
                @click.prevent="sendOtp('email')"
              >
                TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
              </a>
          </div>
          <MemberAdminOtpModal
            :identifier="contactInfo"
            :identifierTypeText="otpType"
            @save="handleVerificationResult"
            @close="closeOtpModal"
          />
          <!-- <div class="validation-error">
            <span>
              <strong>
                Caution
              </strong>
              - Invalid email address, please validate via OTP.
            </span>
          </div> -->

          <div v-if="emailMsg" class="contacts-message-container form-group">
            <div :class="['validate-message', emailValidationMessage.type]">
              <div
                :class="[
                  'message-indicator',
                  `${emailValidationMessage.type}-indicator`,
                ]"
              ></div>
              <span class="message-text">
                <strong :class="`${emailValidationMessage.type}-text`">{{
                  emailValidationMessage.title
                }}</strong>
                -
                {{ emailValidationMessage.message }}
              </span>
            </div>
          </div>
        </div>

        <b-form-group
          id="input-group-2"
          label="Phone"
          label-for="input-2"
          class="required d-block"
        >
          <b-form-input
            id="input-2"
            placeholder="Enter Phone"
            required
            v-model="form.phone"
            @keypress="onlyAllowDigits"
          ></b-form-input>
        </b-form-group>
        <div class="validation-wrapper mb-3">
          <div
              v-if="showOtpSectionPhone"
              class="mem-admin-otp-validate-btn mb-3"
              id="validate_otp"
            >
              <a
                href="#"
                class="validate-via-otp-link validate-btn"
                @click.prevent="sendOtp('phone')"
              >
                TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
              </a>
          </div>
          <div v-if="phoneMsg" class="contacts-message-container form-group">
            <div :class="['validate-message', phoneValidationMessage.type]">
              <div
                :class="[
                  'message-indicator',
                  `${phoneValidationMessage.type}-indicator`,
                ]"
              ></div>
              <span class="message-text">
                <strong :class="`${phoneValidationMessage.type}-text`">{{
                  phoneValidationMessage.title
                }}</strong>
                -
                {{ phoneValidationMessage.message }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper d-flex justify-content-end mt-4">
        <button
          type="submit"
          class="primaryBtn"
          @click.prevent="create"
          :disabled="!form.email || !form.phone"
        >
          <span v-if="!isCreate">Create</span>
          <span v-else>
            <b-spinner small type="grow" />
            Creating...
          </span>
        </button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import MemberAdminOtpModal from "./MemberAdminOtpModal.vue";
import axios from "axios";
export default {
  name: "MemberAdminAdd",
  components: {
    MemberAdminOtpModal,
  },
  data() {
    return {
      form: {
        email: "",
        phone: "",
        skip_validation_email: false,
        skip_validation_phone: false,
      },
      showOtpSectionEmail: false,
      showOtpSectionPhone: false,

      isCreate: false,
      phoneMsg: false,
      emailMsg: false,
      phoneValidationMessage: null,
      emailValidationMessage: null,
      contactInfo: "",
      otpType: "",
      otpDigits: Array(6).fill(''),
      emailVerified: false,
      phoneVerified: false,
    };
  },
  methods: {
    isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
},
    resetForm(){
      this.form.email = "";
      this.form.phone = "";
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.isCreate = false;
      this.phoneMsg = false;
      this.emailMsg = false;
      this.phoneValidationMessage = null;
      this.emailValidationMessage = null;
      this.contactInfo = "";
      this.otpType = "";
      this.form.skip_validation_email = false;
      this.form.skip_validation_phone = false;
    },
    handleVerificationResult(result) {
      let loader = this.$loading.show();
    if (result.verified) {
      // Handle successful verification
      if (result.type === 'email') {
        this.emailmsg = true;
        this.emailVerified = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your email has been verified!'
        };
        this.closeOtpModal();
      this.showOtpSectionEmail = false;
      this.form.skip_validation_email = true;
      } else if (result.type === 'phone') {
        this.phoneMsg = true;
        this.phoneVerified = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your phone has been verified!'
        };
        this.closeOtpModal();
        this.showOtpSectionPhone = false;
        this.form.skip_validation_phone = true;
      }
      setTimeout(() => {
        loader.hide();
      }, 2000);
      this.$notify('Verification successful!');

    }
  },

    // This method restricts the input to only digits and limits the length to 10 digits
    onlyAllowDigits(event) {
      const char = String.fromCharCode(event.which);

      // Allow only digits (0-9)
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
        return;
      }

      // Restrict to max 10 digits
      if (this.form.phone.length >= 10) {
        event.preventDefault();
      }
    },

    validateModal() {
      this.$bvModal.show("validate_otp");
    },

    async create() {
      this.emailMsg = false;
      this.phoneMsg = false;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;

      if (this.form.phone.length < 10 && !this.isValidEmail(this.form.email)) {
        this.$notify("Please enter a valid email address and phone number.", "error");
        return;
      }
      else if (!this.isValidEmail(this.form.email)) {
        this.$notify("Please enter a valid email address.", "error");
        return;
      }
      else if (this.form.phone.length < 10) {
        this.$notify("Please enter a valid phone number.", "error");
        return;
      }


      const url = "add-member-user";
      let loader = this.$loading.show();
      this.isCreate = true;
      try {
        const res = await axios.post(url, this.form);
        this.$notify(res.data.message, "success");
         this.$emit("created");

      } catch (err) {
         const emailError = err.response?.data?.errors?.email;
        const phoneError = err.response?.data?.errors?.phone;

    // Check for undefined errors
    if (phoneError && phoneError.includes("invalid") && !emailError) {
        this.form.skip_validation_email=true;
        this.form.skip_validation_phone=false;
        this.$notify("Phone is invalid. Please validate via OTP", "error");
        this.phoneMsg = true;

        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number. Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;
          this.showOtpSectionEmail = false;



    } else if (emailError && emailError.includes("invalid") && !phoneError) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=true;
        this.$notify("Email is invalid. Please validate via OTP", "error");
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address. Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = false;


    } else if (emailError && emailError.includes("taken") && !phoneError) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=true;
        this.$notify("Email has been already taken.", "error");
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
          this.showOtpSectionEmail = false;
    } else if (phoneError && phoneError.includes("taken") && !emailError) {
        this.form.skip_validation_email=true;
        this.form.skip_validation_phone=false;
        this.$notify("Phone has been already taken.", "error");
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };
          this.showOtpSectionPhone = false;

    } else if (emailError && emailError.includes("taken") && phoneError && phoneError.includes("taken")) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;
        this.$notify("Email and Phone have already been taken.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };
          this.showOtpSectionEmail = false;
          this.showOtpSectionPhone = false;

    } else if (emailError && emailError.includes("invalid") && phoneError && phoneError.includes("invalid")) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;
        this.$notify("Email and Phone are invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address. Please validate via OTP.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number. Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = true;

    } else if (emailError && emailError.includes("taken") && phoneError && phoneError.includes("invalid")) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;
        this.$notify("Email has been already taken and Phone is invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number. Please validate via OTP.",
          };
          this.showOtpSectionEmail = false;
          this.showOtpSectionPhone = true;

    } else if (phoneError && phoneError.includes("taken") && emailError && emailError.includes("invalid")) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;
        this.$notify("Phone has been already taken and Email is invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;

        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };
          this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address. Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = false;
    } else {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;
        this.$notify("An unknown error has occurred.", "error");

    }



      } finally {
        this.isCreate = false;
        setTimeout(() => {
          loader.hide();
        }, 2000);
      }
    },

    async sendOtp(type) {


  // Reset OTP state when switching between email and phone
  
  this.otpDigits = Array(6).fill('');
  this.otpVerified = false;
  this.otpAttempted = false;
  this.otpValidationMessage = null;
  this.verificationSkipped = false;
  this.skipValidationMessage = null;
  this.otpVerificationInProgress = false;
  this.otpType = type;
  this.contactInfo = type === 'email' ? this.form.email : this.form.phone;
  let loader = this.$loading.show();

  try {

    const response = await axios.post(process.env.VUE_APP_CORENROLL_SYSTEM_API_V2+'send-common-otp', {
      contact: this.contactInfo,
      type: this.otpType,
      no_attempt_limit: 1,
      expiry_duration: 600,

    });

    if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
        if (type === 'email') {
    this.openOtpModal('email');
  } else {
    this.openOtpModal('phone');
  }
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
    }
  } catch (error) {
    this.$notify('Failed to send OTP. Please try again.', 'error');
    console.error('OTP send error:', error);
  }
  finally {
loader.hide();

  }
},

    resetValidationState() {
      this.emailMsg = false;
      this.phoneMsg = false;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.contactInfo = "";
      this.otpType = "";
      this.form.skip_validation_email = false;
      this.form.skip_validation_phone = false;
},

 openOtpModal(type) {
      if (type === 'email') {
        this.validateModal();
        // this.contactInfo = this.form.email;
        // this.otpType = 'email';


      } else if (type === 'phone') {
        this.validateModal();
        // this.contactInfo = this.form.phone;
        // this.otpType = 'phone';
      }
      this.otpDigits = Array(6).fill('');
    },
   closeOtpModal() {
   this.$bvModal.hide("validate_otp");


    },
  },

    watch: {
  "form.phone": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.skip_validation_phone=false;   
           }
    },
    immediate: true
  },
  "form.email": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.skip_validation_email=false;
              }
    },
    immediate: true
  }
},


};
</script>

<style>
.validate-message {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  position: relative;
  margin-bottom: 0.75rem;
}

.message-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.message-text {
  flex-grow: 1;
  color: #495057;
  
}
.message-text strong {
  display: inline;
}
.error-text {
  color: #dc3545;
  font-size: 0.875rem !important;
}

.success-text {
  color: #28a745;
}

.warning-text {
  color: #856404;
}

.error-indicator {
  background-color: #dc3545;
}

.success-indicator {
  background-color: #28a745;
}

.warning-indicator {
  background-color: #ffc107;
}

.mem-admin-otp-validate-btn {
  border: 2px solid #e31717;
  max-width: 480px;
  padding: 6px;
  font-size: 15px;
  font-weight: bold;
}

.mem-admin-otp-validate-btn:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
</style>
